export const FAQs: {
  id: string,
  header: string;
  subHeader: string;
  questionsAndAnswers: {
    question: string;
    answer: string;
    children?: string[];
  }[];
}[] = [
  {
    id: "generalInformation",
    header: "General Information",
    subHeader:
      "Understanding the VAIDS 2026 scheme, its purpose, legal foundation, and timeline.",
    questionsAndAnswers: [
      {
        question:
          "What is the Voluntary Assets, Income Declaration and Tax Regularisation Scheme (VAIDS)?",
        answer:
          "VAIDS is a time-limited scheme established by the Executive Order of His Excellency Prof. Chukwuma Charles Soludo CFR, Governor of Anambra State, dated 16 June 2026, which provides a window for taxpayers who have either not registered for taxes or defaulted in payment of taxes due to Anambra State to voluntarily declare their assets and income and regularise their tax position, in exchange for certain reliefs."
      },
      {
        question: "Why is the Governor offering this scheme?",
        answer: "The scheme is offered to:",
        children: [
          "Broaden the tax base",
          "Improve revenue collection",
          "Promote voluntary compliance",
          "Provide defaulting taxpayers an opportunity to regularise without punitive consequences",
          "Enhance infrastructure development funding",
          "Align with global best practices on tax transparency"
        ]
      },
      {
        question: "What is the legal basis for the scheme?",
        answer:
          "The Executive Order made pursuant to the inherent Constitutional Powers of the Governor of Anambra State, dated 16 June 2026, and implemented through Regulations issued by AIRS."
      },
      {
        question: "When does the scheme start and end?",
        answer:
          "The scheme runs for exactly two months from Monday, 6 July 2026 to Friday, 5 September 2026. This is a firm deadline and will NOT be extended."
      },
      {
        question: "Can the scheme period be extended?",
        answer:
          "No. The two-month window is final. No extension will be granted. Taxpayers are strongly advised to participate early."
      }
    ]
  },
  {
    id: "eligibility",
    header: "Eligibility",
    subHeader:
      "Who can participate in the scheme, the taxes covered, and qualifying conditions.",
    questionsAndAnswers: [
      {
        question: "Who is eligible to participate?",
        answer: "All categories of defaulting taxpayers including:",
        children: [
          "Persons who have not registered for tax",
          "Registered taxpayers who have additional disclosures",
          "Those who have not been fully declaring taxable income or assets",
          "Those who have been underpaying or under-remitting",
          "Those currently under tax audit or investigation by the AIRS",
          "Those in existing tax dispute with AIRS",
          "Those with Best of Judgment Assessments who failed to respond"
        ]
      },
      {
        question: "What taxes are covered?",
        answer:
          "All taxes administered by the Anambra State Internal Revenue Service, including personal income tax, withholding tax, capital gains tax, development levy, business premises registration, and all other levies collectible by AIRS, for the preceding six (6) years of assessment."
      },
      {
        question: "What period of default is covered?",
        answer:
          "The preceding six (6) years of assessment prior to the scheme commencement."
      },
      {
        question: "Can corporate entities participate?",
        answer:
          "Yes. Both individuals and corporate entities (companies, partnerships, enterprises) with tax obligations to Anambra State can participate."
      },
      {
        question: "Must I be resident in Anambra State to participate?",
        answer:
          "No. Any person with taxable income from sources within Anambra State can participate, regardless of residence. Non-residents with Anambra-source income are eligible and encouraged to participate."
      },
      {
        question:
          "I am already under tax audit/investigation by AIRS. Can I still participate?",
        answer:
          "Yes. Persons under existing audit or investigation may participate. Upon valid declaration and full payment, the audit/investigation shall be discontinued and the taxpayer granted the reliefs under the scheme."
      },
      {
        question:
          "I am in an existing tax dispute with AIRS. Can I participate?",
        answer:
          "Yes. You may participate and upon valid declaration and payment, the dispute shall be resolved and terminated. Existing objections, appeals, or litigation may be withdrawn by mutual consent."
      },
      {
        question:
          "I have a Best of Judgment (BOJ) Assessment. Can I participate?",
        answer:
          "Yes. You may make a valid declaration, and if AIRS is satisfied, a revised assessment will be issued replacing the BOJ Assessment."
      }
    ]
  },
  {
    id: "registrationAndApplication",
    header: "Registration & Application",
    subHeader:
      "How to register for VAIDS, obtain a TIN, and access application forms.",
    questionsAndAnswers: [
      {
        question: "How do I register/apply for the scheme?",
        answer: "The registration process involves the following steps:",
        children: [
          "Obtain or confirm your Taxpayer Identification Number (TIN)",
          "Complete Form VAIDS-01 (Application Form)",
          "Submit to the VAIDS Unit at AIRS headquarters, Awka, or designated satellite centres",
          "Receive acknowledgment within 5 working days"
        ]
      },
      {
        question: "What if I don't have a TIN?",
        answer:
          "You can obtain a TIN from AIRS as part of the registration process. AIRS will facilitate TIN registration for scheme participants on an expedited basis."
      },
      {
        question: "Where can I obtain the application forms?",
        answer: "Forms are available at:",
        children: [
          "AIRS head office in Awka",
          "Designated satellite centres across all 21 LGAs",
          "The AIRS website (download the form)",
          "Through accredited tax practitioners"
        ]
      }
    ]
  },
  {
    id: "declaration",
    header: "Declaration",
    subHeader:
      "Requirements for making a valid declaration, disclosure obligations, and supporting documentation.",
    questionsAndAnswers: [
      {
        question: "What constitutes a valid declaration?",
        answer: "A declaration must be:",
        children: [
          "Voluntary (not induced by any ongoing enforcement action that compelled it)",
          "Full (covering all relevant assets and income)",
          "Frank (honest and truthful)",
          "Complete (not omitting any material information)",
          "Verifiable (supported by documents or capable of independent verification) in all material respects"
        ]
      },
      {
        question: "What if I have assets held in nominee names?",
        answer:
          "You can and should declare assets held through nominees, agents, or third parties. The declaration form provides for disclosure of beneficial ownership of assets held in nominee names."
      },
      {
        question: "What about overseas assets and income?",
        answer:
          "All assets and income from sources within and outside Nigeria that are subject to Anambra State tax must be declared. This includes income from investments, properties, businesses, and employment outside Nigeria where the taxpayer is subject to AIRS jurisdiction."
      },
      {
        question: "What about assets within Anambra/Nigeria?",
        answer:
          "All assets and income from any source within Anambra State and Nigeria that have not been previously declared for tax purposes must be included."
      },
      {
        question: "Can I declare anonymously?",
        answer:
          "No. Anonymous declarations are not accepted. All declarations must be in the name of the taxpayer with full identification details."
      },
      {
        question:
          "What if my declaration is found to be inaccurate or incomplete?",
        answer:
          "If AIRS determines that a declaration is materially inaccurate or incomplete, the declaration may be rejected, reliefs withdrawn, and the taxpayer will be subject to full enforcement action including penalties and prosecution. However, taxpayers may amend their declarations before assessment is finalized."
      },
      {
        question: "What supporting documents do I need?",
        answer: "Supporting documents include:",
        children: [
          "Bank statements",
          "Property documents",
          "Business records",
          "Financial statements",
          "Evidence of income",
          "Tax returns previously filed (if any)",
          "Any other documents supporting declared assets and income"
        ]
      }
    ]
  },
  {
    id: "payment",
    header: "Payment",
    subHeader:
      "Assessment of tax liabilities, payment methods, instalment plans, and default consequences.",
    questionsAndAnswers: [
      {
        question: "How much tax will I pay?",
        answer:
          "AIRS will assess the actual tax due based on your declaration. You pay only the principal tax—no penalties and no interest—provided you participate within the scheme period."
      },
      {
        question: "Can I pay in instalments?",
        answer:
          "Yes. You may spread payment over a period of up to 24 months, subject to agreement with AIRS. An instalment plan must be formally agreed in writing using Form VAIDS-05."
      },
      {
        question: "What payment channels are available?",
        answer: "Payments can be made through:",
        children: [
          "Direct bank transfer to designated AIRS accounts",
          "Online payment via AIRS payment portal",
          "POS terminals at AIRS offices",
          "Bank drafts"
        ]
      },
      {
        question: "What happens if I default on my instalment plan?",
        answer:
          "If you miss payments without justification, AIRS may revoke the instalment arrangement and demand immediate full payment. Continued default may result in withdrawal of reliefs granted under the scheme."
      }
    ]
  },
  {
     id: "reliefsAndBenefits",
    header: "Reliefs & Benefits",
    subHeader:
      "The incentives and protections available to taxpayers who participate in the VAIDS scheme.",
    questionsAndAnswers: [
      {
        question: "What are the benefits of participating?",
        answer:
          "Participants who make valid declarations and pay assessed tax enjoy:",
        children: [
          "Immunity from prosecution for tax offences",
          "Immunity from tax audit for the declaration period",
          "Waiver of all accumulated interest",
          "Waiver of all penalties",
          "Option to pay in instalments up to 24 months",
          "A Certificate of Compliance",
          "Peace of mind and regularised tax status"
        ]
      },
      {
        question: "What reliefs are available?",
        answer: "Five specific reliefs:",
        children: [
          "Immunity from prosecution",
          "Immunity from audit",
          "Waiver of interest",
          "Waiver of penalties",
          "Instalment payment option"
        ]
      },
      {
        question: "When are the reliefs effective?",
        answer:
          "Reliefs become effective upon issuance of a Certificate of Compliance (for lump sum payments) or upon execution of an instalment plan agreement with AIRS."
      }
    ]
  },
  {
    id: "confidentiality",
    header: "Confidentiality",
    subHeader:
      "How taxpayer information is protected under the VAIDS scheme.",
    questionsAndAnswers: [
      {
        question: "Is my information confidential?",
        answer:
          "Yes. All information provided under the scheme is strictly confidential. It shall not be disclosed except for the purposes of assessment and collection of tax. Any AIRS officer who breaches confidentiality shall be prosecuted."
      },
      {
        question:
          "Can my information be shared with other government agencies?",
        answer:
          "No. Information provided under VAIDS is for AIRS tax administration purposes only and shall not be shared with any other agency."
      }
    ]
  },
  {
    id: "consequencesOfNonParticipation",
    header: "Consequences of Non-Participation",
    subHeader:
      "The enforcement actions and statutory penalties that apply after the VAIDS window closes.",
    questionsAndAnswers: [
      {
        question: "What happens if I don't participate?",
        answer:
          "After the scheme closes on 5 September 2026, AIRS will deploy the full force of the Nigeria Tax Administration Act 2025 against all identified defaulting taxpayers without any further opportunity for amnesty."
      },
      {
        question:
          "What are the specific penalties for non-participation after the window closes?",
        answer: "The following consequences will apply in full:",
        children: [
          "10% penalty on all unpaid tax (Section 65 NTAA 2025)",
          "Interest at CBN Monetary Policy Rate plus applicable spread on all outstanding amounts",
          "Criminal prosecution with imprisonment of up to 3–5 years",
          "Comprehensive tax audit going back 6 years (or unlimited for deliberate misstatement)",
          "Best of Judgment Assessments issued and treated as final and conclusive",
          "Distrain (seizure) of goods, chattels, land and premises (Section 61)",
          "Assignment of tax debts to third-party recovery agents (Section 68)",
          "Failure to register: ₦50,000 first month + ₦25,000 each subsequent month",
          "Failure to file returns: ₦100,000 first month + ₦50,000 each subsequent month",
          "Failure to keep books: ₦10,000 (individual) / ₦50,000 (company)",
          "False declaration: ₦1,000,000 penalty or 3 years imprisonment or both",
          "General penalty: ₦1,000,000 or 3 years imprisonment or both",
          "Recovery as civil debt through the courts",
          "No further amnesty or concession will be available"
        ]
      },
      {
        question: "Will AIRS actually enforce these penalties?",
        answer:
          "Yes. AIRS is committed to robust enforcement post-scheme. The scheme is a one-time opportunity. After 5 September 2026, enforcement will be swift and comprehensive."
      }
    ]
  },
  {
    id: "administration",
    header: "Administration",
    subHeader:
      "How the VAIDS scheme is administered and taxpayers' responsibilities after participation.",
    questionsAndAnswers: [
      {
        question: "Who oversees the scheme?",
        answer:
          "The scheme is administered by the Anambra State Internal Revenue Service (AIRS) through a dedicated VAIDS Unit under the overall supervision of the Executive Chairman of AIRS."
      },
      {
        question: "What are the funds used for?",
        answer:
          "All taxes collected, including those under VAIDS, are used for the development of Anambra State—infrastructure, healthcare, education, security, and other public services."
      },
      {
        question: "What happens to my tax obligations going forward?",
        answer:
          "Participation in VAIDS regularises your past obligations. Going forward, you must continue to comply with all tax obligations, including filing returns, making payments, and keeping proper records. The scheme does not exempt you from future tax compliance."
      }
    ]
  },
  {
    id: "additionalInformation",
    header: "Additional Information",
    subHeader:
      "Where to obtain assistance and professional guidance regarding the VAIDS scheme.",
    questionsAndAnswers: [
      {
        question: "Where can I get more information?",
        answer: "You can contact AIRS through:",
        children: [
          "VAIDS Unit, AIRS Headquarters, Awka",
          "Telephone hotlines (to be announced)",
          "AIRS website",
          "Email",
          "Social media channels",
          "Or consult your tax adviser"
        ]
      },
      {
        question: "Can I use a tax consultant to assist me?",
        answer:
          "Yes. You are encouraged to seek professional assistance from qualified tax practitioners, chartered accountants, or tax lawyers who have been fully registered with and accredited by the AIRS."
      }
    ]
  }
]

export const SIDE_NAV: {id: string, label: string, badge: string}[] = [
  {
    id: "generalInformation",
    label: "General Information",
    badge: "A"
  },
  {
    id: "eligibility",
    label: "Eligibility",
    badge: "B"
  },
  {
    id: "registrationAndApplication",
    label: "Registration & Application",
    badge: "C"
  },
  {
    id: "declaration",
    label: "Declaration",
    badge: "D"
  },
  {
    id: "payment",
    label: "Payment",
    badge: "E"
  },
  {
    id: "reliefsAndBenefits",
    label: "Reliefs & Benefits",
    badge: "F"
  },
  {
    id: "confidentiality",
    label: "Confidentiality",
    badge: "G"
  },
  {
    id: "consequencesOfNonParticipation",
    label: "Consequences of Non-participation",
    badge: "H"
  },
  {
    id: "administration",
    label: "Administration",
    badge: "I"
  },
  {
    id: "additionalInformation",
    label: "More Information",
    badge: "J"
  },
] 
